import { render, staticRenderFns } from "./user_list.vue?vue&type=template&id=a87a6cd4&"
import script from "./user_list.vue?vue&type=script&lang=js&"
export * from "./user_list.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports